module.exports = __webpack_public_path__ + "static/media/ico-csharp.9bd29523.svg";